import { FontSize } from "~/state/settings";

export const SCALING_FACTORS = {
  [FontSize.Small]: 0.7,
  [FontSize.Medium]: 1,
  [FontSize.Large]: 1.3,
};
